import { useEffect, useMemo, useState } from "react";
import { FleetTireManufacturer, TireType, TireWidth, TireHeight, TireRadius } from "services/api/fleet/tires/types";
import { getTireTypesAPI, getTireWidthsAPI, getTireHeightsAPI, getTireRadiusAPI } from "services/api/fleet/tires/api";
import { getTireManufacturersAPI } from "services/api/calculations/tire/api";
import { PaginationDirection } from "services/url";
import { DropdownOption } from "ui/components/Dropdown/Dropdown/types";

export const useTireDropdownOptions = () => {
    const [tireTypes, setTireTypes] = useState<TireType[]>([]);
    const [tireWidths, setTireWidths] = useState<TireWidth[]>([]);
    const [tireHeights, setTireHeights] = useState<TireHeight[]>([]);
    const [tireRadiusList, setTireRadiusList] = useState<TireRadius[]>([]);
    const [tireManufacturers, setTireManufacturers] = useState<FleetTireManufacturer[]>([]);

    useEffect(() => {
        const defaultPagination = {
            pageNumber: 1,
            pageSize: 100,
            sort: { sortBy: "name", direction: PaginationDirection.Ascending },
        };

        Promise.all([
            getTireTypesAPI(defaultPagination),
            getTireWidthsAPI(),
            getTireHeightsAPI(),
            getTireRadiusAPI(),
            getTireManufacturersAPI(defaultPagination),
        ]).then(([typesRes, widthsRes, heightsRes, radiusRes, manufacturersRes]) => {
            setTireTypes(typesRes.data);
            setTireWidths(widthsRes);
            setTireHeights(heightsRes);
            setTireRadiusList(radiusRes);
            setTireManufacturers(manufacturersRes.data);
        }).catch(() => { /* */ });
    }, []);

    const tireTypeOptions: DropdownOption[] = useMemo(() =>
        tireTypes.map(i => ({ value: i.id, text: i.name })), [tireTypes]);
    const widthOptions: DropdownOption[] = useMemo(() =>
        tireWidths.map(i => ({ value: i.id, text: i.name })), [tireWidths]);
    const heightOptions: DropdownOption[] = useMemo(() =>
        tireHeights.map(i => ({ value: i.id, text: i.name })), [tireHeights]);
    const radiusOptions: DropdownOption[] = useMemo(() =>
        tireRadiusList.map(i => ({ value: i.id, text: i.name })), [tireRadiusList]);
    const manufacturerOptions: DropdownOption[] = useMemo(() =>
        tireManufacturers.map(i => ({ value: i.id, text: i.name })), [tireManufacturers]);

    return {
        tireTypes,
        tireManufacturers,
        widthOptions,
        heightOptions,
        radiusOptions,
        tireTypeOptions,
        manufacturerOptions,
    };
};
